import ScheduleList from './ScheduleList';

export default ScheduleList;